<template>
  <div id="app">
    <!-- <login /> -->
    <router-view />
  </div>
</template>
<script>
import login from "@/views/login/index.vue";
export default {
  components: {
    login
  },
  data() {
    return {}
  }
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
</style>
